export const CybersecurityBannerContentArabic = {
    mainHeading: "خدمات الأمن السيبراني",
    greenHeading: "",
    sectionDescription: "احمِ أصولك الرقمية، وادِر المخاطر، وابنِ مناعة سيبرانية من خلال خدمات الأمن السيبراني لدينا.",
    subHeading: "موثوق بها من قبل الشركات الناشئة والشركات الصغيرة والمتوسطة والمؤسسات الكبيرة في مجال الأمن السيبراني",
    buttonText: "هيا بنا نبدأ",
};

export const cyberSecurityDevelopmentServicesDataArabic = {
    mainHeading: "مجموعتنا الواسعة من خدمات الأمن السيبراني",
    sectionDescription: "احمِ عملك من خلال حلول الأمن السيبراني الشاملة لدينا. نحن نؤمن كل شيء من البيئات السحابية وشبكات المؤسسات إلى تطبيقات الويب من خلال الكشف المتقدم عن التهديدات والتشفير واستراتيجيات الامتثال. ابقَ متقدمًا على التهديدات السيبرانية من خلال حلول أمنية يقودها الخبراء مصممة خصيصًا لاحتياجات عملك.",
    servicesCards: [
        {
            id: "Tab1",
            label: "بوابات الويب الآمنة",
            content:
                "تعد بوابات الويب نقاط وصول حيوية للشركات ولكنها أيضًا أهداف رئيسية للتهديدات السيبرانية. تستخدم حلول بوابة الويب الآمنة لدينا التشفير الشامل والمصادقة متعددة العوامل (MFA) وعناصر التحكم الصارمة في الوصول لحماية البيانات الحساسة. من خلال المراقبة المستمرة والكشف عن التهديدات في الوقت الفعلي، نمنع الوصول غير المصرح به ونخفف من المخاطر السيبرانية. سواء للعملاء أو الموظفين أو تطبيقات الأعمال، تضمن إجراءات الأمان لدينا وصولاً آمنًا وسلسًا للبوابة مع حماية أصولك الرقمية من الاختراقات.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/cybersecurity/burp-suite.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Kali_Linux_Logo.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Wireshark_Logo.png",
                },
            ],
        },
        {
            id: "Tab2",
            label: "تطوير الواجهة الخلفية المدفوع بالأمن السيبراني",
            content:
                "تعد الواجهة الخلفية الآمنة أمرًا بالغ الأهمية لحماية البيانات ومنع التهديدات السيبرانية. نحن نبني بنى خلفية قوية مع التشفير واكتشاف التسلل وعناصر التحكم الصارمة في الوصول. تؤمن حلولنا واجهات برمجة التطبيقات وتمنع تسرب البيانات وتوفر أمانًا قابلاً للتطوير للأنظمة السحابية والمختلطة والمحلية. من خلال الكشف الاستباقي عن التهديدات وتقييمات الثغرات الأمنية، نضمن أن تظل الواجهة الخلفية الخاصة بك مرنة ضد الهجمات، مما يحمي بيانات وعمليات الأعمال الهامة من الوصول غير المصرح به والاختراقات ومخاطر الأمن السيبراني المتطورة.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/cybersecurity/burp-suite.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Kali_Linux_Logo.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Wireshark_Logo.png",
                },
            ],
        },
        {
            id: "Tab3",
            label: "تطوير الواجهة الأمامية الآمنة",
            content:
                "يعد أمان الواجهة الأمامية ضروريًا لحماية تفاعلات المستخدم والبيانات الحساسة. تمنع ممارسات التطوير الآمنة لدينا التهديدات مثل XSS وحقن SQL من خلال المصادقة الآمنة، ومعالجة البيانات المشفرة، وإدارة الجلسات الصارمة. من خلال دمج اختبار الثغرات الأمنية الاستباقي والتحقق الآمن من الإدخال، نحمي التطبيقات من التهديدات السيبرانية. يضمن نهجنا تطبيقات سريعة وموثوقة وسهلة الاستخدام تحافظ على سلامة البيانات مع حماية المستخدمين والشركات من الهجمات الخبيثة ومحاولات الوصول غير المصرح بها.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/cybersecurity/burp-suite.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Kali_Linux_Logo.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Wireshark_Logo.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "خدمات استشارات الأمن السيبراني",
            content:
                "الأمن السيبراني معقد، لكننا نبسطه من خلال استشارات الخبراء. نقوم بتقييم المخاطر، وتعزيز الموقف الأمني، وضمان الامتثال لمعايير GDPR و HIPAA و ISO. تساعد تدقيقاتنا الأمنية، وتقييمات المخاطر، والاستراتيجيات المخصصة الشركات على تخفيف المخاطر السيبرانية، ومنع اختراقات البيانات، وتعزيز المرونة الشاملة. سواء كنت شركة ناشئة أو مؤسسة، يقدم خبراء الأمن السيبراني لدينا رؤى قابلة للتنفيذ وحلولًا هي الأفضل في الصناعة لحماية عملك من التهديدات الرقمية المتطورة والتحديات التنظيمية.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/cybersecurity/burp-suite.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Kali_Linux_Logo.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Wireshark_Logo.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "حلول الأمن السيبراني للمؤسسات",
            content:
                "تواجه المؤسسات تهديدات سيبرانية معقدة تتطلب دفاعات قوية. تؤمن حلول الأمن السيبراني للمؤسسات لدينا الشبكات والبيئات السحابية والتطبيقات من خلال منع التسلل المتقدم، وأمان نقطة النهاية، ومنع فقدان البيانات (DLP). من خلال معلومات التهديدات في الوقت الفعلي، وإدارة معلومات الأمان والأحداث (SIEM)، والمراقبة الاستباقية، نحمي المؤسسات من الاختراقات والوصول غير المصرح به. تضمن إجراءات الأمان الشاملة لدينا استمرارية الأعمال، والامتثال التنظيمي، والحماية طويلة الأجل ضد التهديدات السيبرانية الناشئة.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/cybersecurity/burp-suite.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Kali_Linux_Logo.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Wireshark_Logo.png",
                },
            ],
        },
        {
            id: "Tab6",
            label: "اختبار الاختراق والكشف عن التهديدات",
            content:
                "تتطور التهديدات السيبرانية باستمرار، مما يجعل الأمن الاستباقي أمرًا حيويًا. تحاكي خدمات اختبار الاختراق والكشف عن التهديدات لدينا هجمات العالم الحقيقي، وتحدد نقاط الضعف، وتقدم إصلاحات قابلة للتنفيذ. نحن نجري القرصنة الأخلاقية، وتقييمات الثغرات الأمنية، وتمارين الفريق الأحمر لتقوية دفاعاتك. من خلال الكشف المتقدم عن التهديدات والاستجابة السريعة للحوادث، نساعد الشركات على البقاء في صدارة المخاطر السيبرانية، مما يضمن سد الثغرات الأمنية قبل أن يستغلها المهاجمون. عزز أمانك من خلال نهجنا المدفوع بالخبراء.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/cybersecurity/burp-suite.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Kali_Linux_Logo.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Wireshark_Logo.png",
                },
            ],
        },
        {
            id: "Tab7",
            label: "خدمات تشفير البيانات والامتثال",
            content:
                "تعد حماية بيانات الأعمال والعملاء الحساسة أمرًا بالغ الأهمية للأمن والامتثال. نحن نقدم حلول تشفير متقدمة لتأمين البيانات أثناء النقل وعند التخزين، مما يضمن بقائها محمية من الوصول غير المصرح به. تساعد خدمات الامتثال لدينا الشركات على تلبية المتطلبات التنظيمية مثل GDPR و HIPAA و ISO 27001. من خلال تطبيق التشفير القوي، وأطر الحوكمة، وتقييمات المخاطر، نحمي المعلومات السرية، ونقلل المخاطر القانونية، ونحافظ على معايير الأمان الرائدة في الصناعة عبر جميع الأصول الرقمية.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/cybersecurity/burp-suite.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Kali_Linux_Logo.png",
                },
                {
                    img: "/images/services-icons/cybersecurity/Wireshark_Logo.png",
                },
            ],
        },
    ]
}

export const cyberSecurityTypesOfBuildDataArabic = {
    mainHeading: "الفوائد المؤثرة للأمن السيبراني لعملك",
    sectionDescription: "أصبحت حماية البيانات والأصول الرقمية أكثر أهمية من أي وقت مضى. توفر حلول الأمن السيبراني لدينا أمانًا شاملاً ضد التهديدات السيبرانية، مما يضمن المعاملات الآمنة والامتثال التنظيمي وحماية البنية التحتية القوية. من خلال الكشف عن التهديدات وإدارة المخاطر الخبراء، يمكن للشركات العمل بأمان في بيئة رقمية متطورة.",
    accordianData: [
        {
            id: "collapseOne",
            question: "حماية البيانات الحساسة",
            answer: {
                discription:
                    "تتطور التهديدات السيبرانية دائمًا، وأصبحت حماية بياناتك أكثر أهمية من أي وقت مضى. نحن ننفذ تشفيرًا متقدمًا، وعناصر تحكم وصول آمنة، وبروتوكولات أمان مدفوعة بالامتثال لحماية معلومات عملك الحساسة من الوصول غير المصرح به أو الاختراقات.",
                listTitle: "",
                listContent: [
                    {
                        line: "تشفير شامل لنقل البيانات بشكل آمن",
                    },
                    {
                        line: "مصادقة متعددة الطبقات للتحكم في الوصول بشكل أقوى",
                    },
                    {
                        line: "الامتثال لمعايير الصناعة لأمان قوي",
                    },
                ],
            },
        },
        {
            id: "collapseTwo",
            question: "منع الهجمات السيبرانية",
            answer: {
                discription:
                    "يمكن أن تكون التهديدات السيبرانية مدمرة للشركات، مما يتسبب في أضرار مالية وسمعة. تساعد إجراءات الأمان الاستباقية لدينا، واختبار الاختراق، والكشف عن التهديدات المدفوع بالذكاء الاصطناعي على منع الهجمات السيبرانية قبل حدوثها.",
                // listTitle: "Our native mobile apps are best for:",
                listContent: [
                    {
                        line: "المراقبة الأمنية المستمرة للكشف عن نقاط الضعف",
                    },
                    {
                        line: "الكشف عن التهديدات المدفوع بالذكاء الاصطناعي للتخفيف من المخاطر في الوقت الفعلي",
                    },
                    {
                        line: "اختبار الاختراق المنتظم للكشف عن نقاط ضعف النظام",
                    },
                ],
            },
        },
        {
            id: "collapseThree",
            question: "ضمان الامتثال التنظيمي",
            answer: {
                discription:
                    "الامتثال للأمن السيبراني لا يتعلق بالحماية فقط - بل يتعلق بالثقة. تضمن أطرنا الأمنية المدفوعة بالامتثال أن عملك يلبي لوائح الصناعة مثل GDPR و HIPAA و ISO 27001، مما يحافظ على امتثالك القانوني ومتقدمًا على المخاطر.",
                // listTitle: "Our native mobile apps are best for:",
                listContent: [
                    {
                        line: "تدقيقات الامتثال لتلبية لوائح الصناعة",
                    },
                    {
                        line: "تقييمات المخاطر لتحديد الثغرات الأمنية",
                    },
                    {
                        line: "تخزين بيانات آمن لامتثال أفضل للوائح",
                    },
                ],
            },
        },
        {
            id: "fourth",
            question: "الحفاظ على ثقة العملاء",
            answer: {
                discription:
                    "يتوقع عملاؤك الأمان والخصوصية عند تفاعلهم مع منصاتك الرقمية. تحمي استراتيجيات الأمن السيبراني الشاملة لدينا بيانات المستخدم، مما يضمن تجربة آمنة وجديرة بالثقة عبر جميع نقاط الاتصال الرقمية.",
                // listTitle: "Our native mobile apps are best for:",
                listContent: [
                    {
                        line: "بوابات دفع آمنة لحماية المعاملات",
                    },
                    {
                        line: "حلول تركز على الخصوصية لحماية بيانات المستخدم",
                    },
                    {
                        line: "تحديثات أمنية منتظمة للتخفيف من التهديدات الناشئة",
                    },
                ],
            },
        },
        {
            id: "fifth",
            question: "دعم استمرارية الأعمال",
            answer: {
                discription:
                    "يمكن أن يؤدي هجوم سيبراني واحد إلى توقف العمليات. تضمن حلول استمرارية الأعمال لدينا، بما في ذلك التعافي من الكوارث، والنسخ الاحتياطية السحابية، والتخطيط للاستجابة للحوادث، أن يظل عملك قيد التشغيل مهما حدث.",
                // listTitle: "Our native mobile apps are best for:",
                listContent: [
                    {
                        line: "نسخ احتياطية سحابية تلقائية لاستعادة البيانات بشكل آمن",
                    },
                    {
                        line: "خطط الاستجابة للحوادث للتخفيف السريع من التهديدات السيبرانية",
                    },
                    {
                        line: "بنية أمنية مرنة لمنع التوقف",
                    },
                ],
            },
        },
    ]
}

export const cyberSecurityWhoWeServeDataArabic = {
    mainHeading: "من نخدم",
    sectionDescription: "من الشركات الناشئة التي تؤمن أصولها الرقمية الأولى إلى المؤسسات الكبيرة التي تحتاج إلى حلول أمن سيبراني، نقدم حماية للبيانات تتوسع مع احتياجاتك. تضمن خدمات الأمن السيبراني لدينا أمن الشبكة، والكشف عن التهديدات، والامتثال، مما يحافظ على أمان عملك في عالم رقمي دائم التطور.",
    cardsData: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "الشركات الناشئة الصاعدة",
            description:
                "غالبًا ما تفتقر الشركات الناشئة إلى خبراء الأمن السيبراني الداخليين. نقدم حلول أمن سيبراني ميسورة التكلفة وقابلة للتطوير لحماية البيانات الحساسة من التهديدات السيبرانية.",
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "الأمن السيبراني لشركات SaaS والتقنية",
            description:
                "تتطلب شركات التكنولوجيا أمنًا قويًا للشبكة واختبار الاختراق. نحن ننفذ تدابير قوية لحماية البيانات لمنع الثغرات الأمنية.",
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "الأمن على مستوى المؤسسات للشركات",
            description:
                "تتعامل المؤسسات مع كميات هائلة من البيانات. توفر خدمات الأمن السيبراني لدينا كشفًا متقدمًا للتهديدات ودعم الامتثال لتجنب الاختراقات.",
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const cyberSecurityWhyChooseBitsclanDataArabic = {
    mainHeading: "لماذا تختار بيتسكلان شريكك في خدمات الأمن السيبراني؟",
    sectionDescription: "في عالم تتطور فيه التهديدات السيبرانية باستمرار، لم تعد حماية عملك مجرد خيار - بل ضرورة. تقدم بيتسكلان حلولًا متطورة للأمن السيبراني، وكشفًا استباقيًا للتهديدات، واستشارات أمنية متخصصة لحماية أنظمتك وبياناتك ومستخدميك. يضمن نهجنا بقاء مؤسستك آمنة ومتوافقة ومرنة في مواجهة المخاطر السيبرانية.",
    cardsData: [
        {
            id: "Tab1",
            label: "جودة لا تضاهى",
            content:
                "الأمان هو جوهر كل ما نقوم به. تم بناء حلول الأمن السيبراني لدينا بدقة، مما يضمن حماية متعددة الطبقات تحمي عملك من خروقات البيانات وبرامج الفدية والوصول غير المصرح به. نحن نلتزم بأعلى معايير الصناعة لتقديم حلول أمنية موثوقة وقابلة للتطوير.",
            btnText: "تواصل مع الفريق",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "مواهب من الطراز الأول",
            content:
                "يتكون فريقنا من محترفي الأمن السيبراني ذوي الخبرة، وقراصنة أخلاقيين، ومتخصصين في الامتثال الذين يجلبون خبرة صناعية عميقة. من اختبار الاختراق إلى الاستجابة للحوادث، نقدم إرشادات الخبراء لمساعدتك في بناء إطار عمل قوي للأمن السيبراني.",
            btnText: "تواصل مع الفريق",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "مواءمة المنطقة الزمنية",
            content:
                "التهديدات السيبرانية لا تنتظر، ونحن كذلك. مع فريق موزع عالميًا، نقدم دعمًا أمنيًا على مدار الساعة طوال أيام الأسبوع، واستجابة للحوادث، ومراقبة في الوقت الفعلي، مما يضمن بقاء عملك محميًا بغض النظر عن منطقتك الزمنية أو موقعك.",
            btnText: "تواصل مع الفريق",
            btnLink: "#",
        },
        {
            id: "Tab4",
            label: "إدارة التهديدات الاستباقية",
            content:
                "بدلاً من الرد على الحوادث الأمنية بعد وقوعها، نتبع نهجًا استباقيًا. باستخدام التحليلات المدفوعة بالذكاء الاصطناعي، والكشف عن التهديدات السلوكية، وتقييمات الثغرات الأمنية، نحدد المخاطر مبكرًا وننفذ استراتيجيات التخفيف لمنع الاختراقات قبل حدوثها.",
            btnText: "تواصل مع الفريق",
            btnLink: "#",
        },
        {
            id: "Tab5",
            label: "أمان جاهز للامتثال",
            content:
                "الامتثال التنظيمي جانب حاسم من الأمن السيبراني الحديث. نحن نساعد الشركات على تلبية والحفاظ على الامتثال للمعايير مثل GDPR و HIPAA و ISO 27001 و SOC 2 و PCI-DSS. تضمن استراتيجياتنا الأمنية المخصصة أن تظل مؤسستك متوافقة مع تقليل المخاطر والمسؤوليات القانونية.",
            btnText: "تواصل مع الفريق",
            btnLink: "#",
        },
    ]
}

export const cyberSecurityHighvaluesDataArabic = {
    mainHeading: "ميزات الأمن السيبراني الأساسية للحماية الرقمية التي لا مثيل لها",
    sectionDescription: "مع تزايد تطور التهديدات السيبرانية، تحتاج الشركات إلى تدابير أمنية قوية لحماية البيانات الحساسة، ومنع الاختراقات، وضمان الامتثال. تم تصميم حلول الأمن السيبراني المتطورة لدينا لحماية بنيتك التحتية الرقمية من خلال الكشف عن التهديدات في الوقت الفعلي، وإدارة المخاطر الاستباقية، والتشفير وفقًا لمعايير الصناعة.",
    buttonText: "استشر نطاق المشروع",
    cardsData: [
        {
            image: "custom-app-development.svg",
            text: "الكشف المتقدم عن التهديدات",
        },
        {
            image: "user-centric-designs.svg",
            text: "تشفير البيانات من طرف إلى طرف",
        },
        {
            image: "robust-architecture.svg",
            text: "بنية تحتية آمنة للشبكة",
        },
        {
            image: "efficient-integration.svg",
            text: "إدارة الهوية والوصول",
        },
        {
            image: "advanced-analytics.svg",
            text: "مراقبة أمنية في الوقت الفعلي",
        },
        {
            image: "enhanced-security.svg",
            text: "تحليل المخاطر المدعوم بالذكاء الاصطناعي",
        },
        {
            image: "agile-methodology.svg",
            text: "حلول أمان سحابية",
        },
        {
            image: "cross-platform-support.svg",
            text: "الأمن التنظيمي والامتثال",
        },
        {
            image: "ongoing-maintenance.svg",
            text: "الاستجابة للحوادث والاستعادة",
        },
        {
            image: "innovation-driven-features.svg",
            text: "التدريب والتوعية بالأمن السيبراني",
        },
    ],
};

export const CybersecurityRoadmapDataArabic = {
    heading: "خارطة طريقنا المثبتة لتأمين عملك",
    description:
        "تتطور التهديدات السيبرانية، ويجب أن تتطور استراتيجية الأمان لديك أيضًا. يضمن نهجنا المنظم بقاء عملك محميًا بحلول أمن سيبراني متطورة. من تقييم نقاط الضعف إلى الصيانة الأمنية المستمرة، نتبع عملية مبسطة تضمن حماية قوية، واكتشاف سريع للتهديدات، والامتثال لمعايير الصناعة. إليك كيف نقوم بذلك:",
    roadMapHeading: [
        "تقييم الأمان والتخطيط",
        "الاستراتيجية والتنفيذ",
        "الامتثال وإدارة المخاطر",
        "الحماية والدعم المستمران",
    ],
    roadMapsteps: [
        "نقوم بتحليل إعدادات الأمان الحالية لديك، وتحديد نقاط الضعف، وإنشاء خطة عمل قوية لحماية عملك من التهديدات السيبرانية.",
        "يقوم خبراؤنا بتصميم وتطبيق تدابير أمنية، ودمج الكشف المتقدم عن التهديدات، والتشفير، وحماية البيانات لبناء نظام مرن.",
        "نحن نضمن أن عملك يفي بالمتطلبات التنظيمية، مما يقلل المخاطر من خلال المراقبة المستمرة، وإنفاذ السياسات، وبروتوكولات الأمان الاستباقية.",
        "التهديدات السيبرانية لا تتوقف عن التطور، ونحن كذلك. يوفر فريقنا مراقبة على مدار الساعة طوال أيام الأسبوع، واستجابة سريعة للحوادث، وتحديثات منتظمة للحفاظ على أمانك.",
    ],
};

export const cyberSecurityCoverTheStackArabic = {
    mainHeading: "حسّن أمنك السيبراني باستخدام حزمة التقنيات الرائدة في الصناعة",
    sectionDescription: "في Bitsclan، نضمن أن تكون عمليات ديف أوبس الخاصة بك مدعومة بأحدث التقنيات المتوفرة. تم تصميم حزمة التقنيات المختارة بعناية لتعزيز الكفاءة، والأمان، وقابلية التوسع في كل مرحلة من مراحل دورة حياة تطوير البرمجيات.",
    defaultTabOpen: "الواجهة الأمامية",
    tabs: [
        "الواجهة الخلفية",
        "الواجهة الأمامية",
        "قواعد البيانات",
        "أطر العمل",
        "ديف أوبس",
        "ضمان الجودة",
    ],

    tabItems: [
        { tab: "الواجهة الأمامية", icon: "/images/iconone.png", name: "Angular JS" },
        { tab: "الواجهة الأمامية", icon: "/images/icontwo.png", name: "JavaScript" },
        { tab: "الواجهة الأمامية", icon: "/images/iconthree.png", name: "React JS" },
        { tab: "الواجهة الأمامية", icon: "/images/icon4.png", name: "Vue JS" },
        { tab: "الواجهة الأمامية", icon: "/images/mobile3.png", name: "Swift" },
        { tab: "الواجهة الأمامية", icon: "/images/icon6.png", name: "CSS3" },
        { tab: "الواجهة الأمامية", icon: "/images/icon7.png", name: "HTML5" },
        { tab: "الواجهة الخلفية", icon: "/images/database1.png", name: ".Net" },
        { tab: "الواجهة الخلفية", icon: "/images/database2.png", name: "Nest Js" },
        { tab: "الواجهة الخلفية", icon: "/images/database3.png", name: "Meteor JS" },
        { tab: "الواجهة الخلفية", icon: "/images/database5.png", name: "Express JS" },
        { tab: "الواجهة الخلفية", icon: "/images/database6.png", name: "Python" },
        { tab: "الواجهة الخلفية", icon: "/images/django-tech.svg", name: "Django" },
        { tab: "الواجهة الخلفية", icon: "/images/database8.png", name: "PHP" },
        { tab: "الواجهة الخلفية", icon: "/images/database9.png", name: "Node Js" },
        { tab: "قواعد البيانات", icon: "/images/db1.png", name: "Firebase" },
        { tab: "قواعد البيانات", icon: "/images/db2.png", name: "Oracle" },
        { tab: "قواعد البيانات", icon: "/images/db3.png", name: "MongoDB" },
        { tab: "قواعد البيانات", icon: "/images/tech-stack-icons/postgres.svg", name: "PostgreSQL" },
        { tab: "قواعد البيانات", icon: "/images/db5.png", name: "MySQL" },
        { tab: "قواعد البيانات", icon: "/images/db6.png", name: "SQL Server" },
        { tab: "قواعد البيانات", icon: "/images/db7.png", name: "SQLite" },
        { tab: "قواعد البيانات", icon: "/images/db8.png", name: "DynamoDB" },
        { tab: "أطر العمل", icon: "/images/framework1.png", name: "MEAN" },
        { tab: "أطر العمل", icon: "/images/framework2.png", name: "CodeIgniter" },
        { tab: "أطر العمل", icon: "/images/framework3.png", name: "Laravel" },
        { tab: "أطر العمل", icon: "/images/framework4.png", name: "Rxweb.io" },
        { tab: "أطر العمل", icon: "/images/framework5.png", name: "CakePHP" },
        { tab: "أطر العمل", icon: "/images/framework6.png", name: "Django" },
        { tab: "ديف أوبس", icon: "/images/devops1.png", name: "Gradle" },
        { tab: "ديف أوبس", icon: "/images/devops2.png", name: "Kubernetes" },
        { tab: "ديف أوبس", icon: "/images/devops3.png", name: "Docker" },
        { tab: "ديف أوبس", icon: "/images/devops4.png", name: "Jenkins" },
        { tab: "ضمان الجودة", icon: "/images/qa1.svg", name: "TestRail" },
        { tab: "ضمان الجودة", icon: "/images/qa2.svg", name: "LoadRunner" },
        { tab: "ضمان الجودة", icon: "/images/qa3.svg", name: "Cucumber" },
        { tab: "ضمان الجودة", icon: "/images/qa4.svg", name: "TestNG" },
        { tab: "ضمان الجودة", icon: "/images/qa5.svg", name: "Appium" },
        { tab: "ضمان الجودة", icon: "/images/qa6.svg", name: "Selenium" },
    ]
};

export const cyberSecurityIndustriesHeadingArabic = {
    mainHeading: "الصناعات التي نخدمها في مجال الأمن السيبراني"
}

export const cyberSecurityFaqDataArabic = {
    mainHeading: "الأسئلة الشائعة",
    sectionDescription: "احصل على إجابات سريعة لأسئلتك حول عملية وخدمات تطوير تطبيقات الهاتف المحمول لدينا.",
    questionAnswer: [
        {
            id: "collapseOne",
            question: "لماذا أحتاج إلى خدمات الأمن السيبراني لعملي؟",
            answer:
                "التهديدات السيبرانية في كل مكان، وهجوم واحد يمكن أن يعرض عملك للخطر. تحافظ خدمات الأمن السيبراني لدينا على بياناتك آمنة، وتمنع الاختراقات، وتضمن سلاسة العمليات.",
        },
        {
            id: "collapseTwo",
            question: "كيف تحمون عملي من الهجمات السيبرانية؟",
            answer:
                "نحن نستخدم مزيجًا من الأدوات المتقدمة مثل اكتشاف التهديدات والتشفير والمراقبة في الوقت الفعلي لاكتشاف التهديدات السيبرانية وإيقافها قبل أن تتسبب في أي ضرر.",
        },
        {
            id: "collapseThree",
            question: "هل الأمن السيبراني مخصص للشركات الكبيرة فقط؟",
            answer:
                "ليس على الإطلاق! سواء كنت شركة ناشئة أو مؤسسة كبيرة، فإن مجرمي الإنترنت لا يميزون. حلول الأمن السيبراني لدينا مصممة خصيصًا للشركات من جميع الأحجام.",
        },
        {
            id: "fourth",
            question: "ماذا يحدث إذا تعرض عملي للاختراق؟",
            answer:
                "إذا حدث اختراق، يتصرف فريقنا بسرعة لاحتوائه، وتقليل الضرر، واستعادة البيانات المفقودة. بالإضافة إلى ذلك، نساعدك على تعزيز الأمان لمنع الهجمات المستقبلية.",
        },
        {
            id: "fifth",
            question: "هل أحتاج إلى الأمن السيبراني حتى لو كان لدي برنامج مكافحة فيروسات؟",
            answer:
                "نعم! برنامج مكافحة الفيروسات هو مجرد طبقة واحدة من الحماية. تغطي خدمات الأمن السيبراني لدينا كل شيء بدءًا من أمان الشبكة إلى تشفير البيانات والدفاع الاستباقي ضد التهديدات.",
        },
        {
            id: "sixth",
            question: "كيف يمكنني البدء في استخدام خدمات الأمن السيبراني الخاصة بكم؟",
            answer:
                "الأمر بسيط للغاية! ما عليك سوى التواصل معنا، وسنقوم بتقييم احتياجاتك الأمنية، والتوصية بالحلول، وتوفير الحماية الكاملة لك في أي وقت من الأوقات.",
        },
    ],
};